import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const StarIcon = ({ fill='#000', ...props }) => {
  return (
    <Icon viewBox="0 0 80 80" {...props}>
      <path
        fill={fill}
        d="M78.303,34.2798889 C79.8607778,32.6954444 80.3874444,30.6432222 79.7118889,28.7887778 C79.0352222,26.9343333 77.3096667,25.7021111 75.0907778,25.491 L53.5918889,23.4865556 C53.4985556,23.4432222 53.3652222,23.3465556 53.2952222,23.271 L44.653,3.34544444 C43.743,1.24988889 42.0041111,-0.000111111111 39.9974444,-0.000111111111 C37.993,-0.000111111111 36.2518889,1.24988889 35.3418889,3.34766667 L26.7074444,23.2676667 C26.6374444,23.3432222 26.5018889,23.4432222 26.4074444,23.4865556 L4.91188889,25.4954444 C2.69855556,25.6987778 0.970777778,26.9265556 0.291888889,28.7821111 C-0.388111111,30.6376667 0.137444444,32.6932222 1.69744444,34.2798889 L17.9552222,50.8198889 C18.0085556,50.9243333 18.0574444,51.1154444 18.0607778,51.2332222 L11.7518889,73.5365556 C10.7763333,76.9532222 12.7507778,78.6976667 13.3785556,79.151 C14.0074444,79.6043333 16.2874444,80.9287778 19.2252222,78.921 L39.9974444,64.7087778 L60.773,78.9221111 C61.9607778,79.7332222 63.0407778,79.9998889 63.9474444,79.9998889 C65.2818889,79.9998889 66.243,79.421 66.6174444,79.151 C67.2452222,78.6976667 69.2196667,76.9532222 68.2474444,73.5476667 L61.9374444,51.2243333 C61.9407778,51.1098889 61.9885556,50.9232222 62.0396667,50.8198889 L78.303,34.2798889 Z"
      />
    </Icon>
  );
};

StarIcon.propTypes = {
  fill: PropTypes.string,
};

export default StarIcon;
